import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import {
  UploadData,
  FileInfo,
  FileUploadStatus,
  FileUploadStatusRes,
  FaqDetail,
  TaxInfo,
} from "./types";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 获取upload页面信息
export function getUpload(): Promise<UploadData> {
  return request.post<UploadData>(`${baseUrl}/sofipo/v0/personalFiscalInfo/uploadPage`, {});
}

// 上传文件
export function postFile(params: FileInfo): Promise<FileUploadStatus> {
  return request.post<FileUploadStatus>(
    `${baseUrl}/sofipo/v0/personalFiscalInfo/uploadPdf`,
    params,
  );
}

// 使用FormData上传文件（支持文件流）
export function postFileWithFormData(formData: FormData): Promise<FileUploadStatus> {
  return request.post<FileUploadStatus>(
    `${baseUrl}/sofipo/v0/personalFiscalInfo/uploadPdf`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
}

// 获取文件上传结果
export function getUpLoadResult(params: { id: string }): Promise<FileUploadStatus> {
  return request.post<FileUploadStatus>(`${baseUrl}/sofipo/v0/main/earning/calc`, params);
}

// 获取文件上传状态 成功 失败 上传中}
export function getUploadStatus(params: { orderId?: string }): Promise<FileUploadStatusRes> {
  return request.post<FileUploadStatusRes>(
    `${baseUrl}/sofipo/v0/personalFiscalInfo/queryPDFStatus`,
    params,
  );
}
// 获取faq详情
export function getFaqDetail(params: { qaId?: string }): Promise<FaqDetail> {
  return request.post<FaqDetail>(`${baseUrl}/sofipo/v0/personalFiscalInfo/qaDetail`, params);
}

// 获取税务信息详情
export function getTaxDetail(params: { orderId?: string }): Promise<TaxInfo> {
  return request.post<TaxInfo>(`${baseUrl}/sofipo/v0/personalFiscalInfo/detail`, params);
}
